'use client';

import { ComponentProps, FC } from 'react';
import { IconShare } from 'src/general/Icons/IconShare';
import { Button } from '../Button/Button';
import { ToasterService } from '../Toaster/ToasterService';

type Props = {
  label?: string;
} & Partial<Pick<ComponentProps<typeof Button>, 'variant' | 'size' | 'className'>>;

export const ShareButton: FC<Props> = ({ label = 'Share', variant = 'tertiary', size = 'small', className }) => {
  const sharePage = () => {
    const currentUrl = window.location.href;
    const shareData = { url: currentUrl };
    if (!!navigator.canShare && navigator.canShare(shareData)) {
      navigator.share({ url: currentUrl }).catch((_error) => {
        // Nothing to do, error thrown when share dismissed without sharing
      });
    } else {
      navigator.clipboard.writeText(currentUrl);
      ToasterService.success({ message: 'URL copied to clipboard' });
    }
  };

  return (
    <Button
      startIcon={<IconShare />}
      onClick={sharePage}
      data-testid="SHARE_BUTTON"
      variant={variant}
      size={size}
      className={className}
    >
      {label}
    </Button>
  );
};
